import React, { lazy, Suspense, useState } from 'react'
import Layout from "../components/layout";
import { useQuery } from "@apollo/client";
import HomePageSlider from "../components/HomePageSlider";
import FeaturedCard from "../components/newComponents/featuredCard";
import CardsCarousel from "../components/CardsCarousel";
import ProjectCardsCarousel from "../components/projectCardCarousel";
import YoutubeEmbed from '../components/newComponents/youtubeEmbed';
import { useDisclosure } from "@chakra-ui/react";
const ModalComponent = lazy(() => import("../components/newComponents/modalComponent").then((module) => ({ default: module.ModalComponent }))); 
import ImgixFluidImage from '../components/newComponents/ImgixFluidImage';
import { NavLink } from "react-router";
import { HandleQuery, HomeData } from "../queries";
import IcoPlay from "../images/ico-play.png";
import Seo from "../components/seo";

export function Home()
{
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [index, setIndex] = useState(Math.floor(Math.random() * 35));

    const query_state = useQuery(HomeData);
    const { complete, view } = HandleQuery(query_state);
    if(!complete) return view;
    const data = query_state.data; 

    const featuredTeamMembers = data.relatedTeamMembersVideos[0].bodyContent.filter((item) => item.id == 24485)[0].featuredTeamMembers;
    const featuredPerson = featuredTeamMembers[Math.min(index, featuredTeamMembers.length - 1)];
    const projects = data.projectPosts[0].bodyContent.filter((item) => item.id == 30052)[0].project;

  return (
  <>
    <Layout>
      <Seo />
      <HomePageSlider data={data.home.carousel} alert={data.home.alert} />
      <main className="main">
        <section className="section-boxes section-boxes--secondary">
          <div className="shell">
            <header className="section__head">
              <p className="section__title title h2 text-gray">{data.home.homeWhatWeDoTitle}</p>
              <p className="section__subtitle subtitle text-orange">{data.home.homeWhatWeDoSlogan}</p>
              <div className="section__head-description" dangerouslySetInnerHTML={{ __html: data.home.homeWhatWeDoIntro }}/>
            </header>
          </div>
        </section>
        <section className="section-boxes section-boxes--news">
          <div className="shell">
            <header className="section__head">
              <p className="section__title title h2 text-gray">Genesis in the news</p>
              <p className="section__subtitle subtitle text-orange">NEWS &amp; INSIGHTS</p>
            </header>
            <div className="boxes boxes--news">
              <ul>
                <FeaturedCard title={data.newsPosts[0].displayTitle} subtitle={data.newsPosts[0].summary} href={`/${ data.newsPosts[0].uri}`} image={data.newsPosts[0].featureImage[0]}/>
              </ul>
              <CardsCarousel cards={data.newsPosts.slice(1)}></CardsCarousel>
            </div>
            <NavLink to="/news" className="section__btn btn btn--green">More news</NavLink>
          </div>
        </section>
        <section className="section-projects">
          <div className="shell">
            <CardsCarousel cards={data.home.homeWhatWeDoEntries} color={0} backgroundColor={1}></CardsCarousel>
            <hr className="border-b border-[#e0e0e0] my-[57px]"/>
            <header className="section__head">
              <div className="section__head-inner">
                <figure className="section__head-image hidden-xs w-1/3">
                  <ImgixFluidImage width={350} attribution={data.home.homePageOurPurposeImage[0].attribution} image={data.home.homePageOurPurposeImage[0]} focalPoint={data.home.homePageOurPurposeImage[0].focalPoint} ar={data.home.homePageOurPurposeImage[0].width / data.home.homePageOurPurposeImage[0].height}/>
                </figure>
                <div className="section__head-content">
                  <p className="section__title title h2 text-gray">{data.home.homeOurPurposeTitle}</p>
                  <p className="section__subtitle subtitle text-orange">{data.home.homePageOurPurposeSlogan}</p>
                  <figure className="section__head-image hidden-sm hidden-md hidden-lg">
                    <ImgixFluidImage width={710} attribution={data.home.homePageOurPurposeImage[0].attribution} image={data.home.homePageOurPurposeImage[0]} focalPoint={data.home.homePageOurPurposeImage[0].focalPoint} />
                  </figure>
                  <div className="section__head-entry richtext-entry">
                    <div dangerouslySetInnerHTML={{ __html: data.home.homeOurPurposeSummary }}/>
                  </div>
                  <NavLink to="/our-purpose" className="section__head-link link-more text-gray-3">Read more <span className="sr-only">about our purpose</span></NavLink>
                </div>
              </div>
            </header>
            <div className="boxes swiper-container js-slider-boxes-projects swiper-container-initialized swiper-container-horizontal">
              <ProjectCardsCarousel cards={projects} limit={3}/>
            </div>
            <NavLink to="/our-purpose" className="section__btn btn btn--green">More projects <span className="sr-only">about our purpose</span></NavLink>
          </div>
        </section>
        <section className="section-text-image">
          <div className="shell">
            <div className="section__inner">
              <div className="section__content">
                <p className="section__title title h2 text-gray">{data.home.homeJoinOurTeamHeading}</p>
                <p className="section__subtitle subtitle text-orange" dangerouslySetInnerHTML={{ __html: data.home.homePageJoinOurTeamSlogan }}></p>

                <a href="/"  onClick={(event) => { event.preventDefault(); onOpen(); }}>
                  <figure className="section__image hidden-sm hidden-md hidden-lg" >
                    <img className="section__image-icon z-20" src={IcoPlay} alt=""/>
                    <p className="section__image-text z-30">
                      <span>Why I chose Genesis</span>
                    </p>
                      <div className="relative" style={{width: "100%"}}>
                        <ImgixFluidImage width={710} attribution={featuredPerson.featureImage[0].attribution} image={featuredPerson.featureImage[0]} focalPoint={featuredPerson.featureImage[0].focalPoint} ar={3/2}/>
                        <span className="absolute bottom-1 left-0 top-0 right-0 bg-gray-500 bg-opacity-30"></span>
                      </div>
                  </figure>
                </a>
                <div className="section__entry">
                  <div dangerouslySetInnerHTML={{ __html: data.home.homePageJoinOurTeamText }}/>
                </div>
                <a href={ data.home.homePageJoinOurTeamLinkUrl1 } className="section__link link-more text-red">{ data.home.homePageJoinOurTeamLinkText1 }</a>
                <br/>
                <a href={ data.home.homePageJoinOurTeamLinkUrl2 } className="section__link link-more text-red">{ data.home.homePageJoinOurTeamLinkText2 }</a>
              </div>
              <a href="/" aria-label="Why I chose Genesis" onClick={(event) => { event.preventDefault(); onOpen();}}>
                <figure className="section__image hidden-xs" >
                  <img className="section__image-icon z-20" src={IcoPlay} alt=""/>
                  <p className="section__image-text z-30">
                    <span>Why I chose Genesis</span>
                  </p>
                    <div className="relative" style={{height: "500px", width: "350px", overflow: "hidden"}}>
                      <ImgixFluidImage width={350} attribution={featuredPerson.featureImage[0].attribution} image={featuredPerson.featureImage[0]} focalPoint={featuredPerson.featureImage[0].focalPoint} ar={7/10}/>
                      <span className="absolute bottom-0 left-0 w-full h-full bg-gray-500 bg-opacity-30"></span>
                    </div>
                </figure>
              </a>
              <Suspense fallback={<></>}>
                <ModalComponent isOpen={isOpen} onClose={onClose} title={featuredPerson.displayTitle}>
                    <YoutubeEmbed title={featuredPerson.staffCareersVideo.title} url={featuredPerson.staffCareersVideo.url} />
                </ModalComponent>
              </Suspense>
            </div>
          </div>
        </section>
      </main>   
    </Layout>
 </>
  )
}
